import { useContext } from 'react';
import { CheckoutContext } from '../../contexts/CheckoutContext';
import GoogleAdsPixels from './GoogleAdsPixels';
import GoogleAnalyticsPixels from './GoogleAnalyticsPixels';
import FacebookPixels from './FacebookPixels';
import TikTokPixels from './TikTokPixels';
import KwaiPixels from './KwaiPixels';

const TrackingPixels = () => {
  const { offer } = useContext(CheckoutContext);

  return (
    <>
      <GoogleAnalyticsPixels trackingId={offer?.tracking_pixels?.googleAnalyticsTrackingId || ''} />
      <GoogleAdsPixels pixels={offer?.tracking_pixels?.google_ads_pixels || []} />
      <FacebookPixels />

      <TikTokPixels />

      <KwaiPixels />
    </>
  );
};

export default TrackingPixels;
